import { IconButton, Stack, Typography } from '@mui/material';
import { DropdownIcon, ListAccordion, ListAccordionContext, SectionBlock } from '@schooly/style';
import { FC, ReactNode, useContext } from 'react';
import { useIntl } from 'react-intl';

import { useTeacherDashboardPermissions } from '../../useTeacherDashboardPermissions';
import { EmptyState } from '../../TeacherDashboardContent';
import { GroupsWidget } from './GroupsWidget';
import { useGroupsWidgetData } from './useGroupsWidgetData';

export const GroupsSectionBlock: FC = () => {
  const { formatMessage } = useIntl();
  const { canViewAttendance, canManageAttendance } = useTeacherDashboardPermissions();
  const data = useGroupsWidgetData({ canViewAttendance });

  const title = (
    <Typography variant="h2">{formatMessage({ id: 'dashboard-teacher-MyGroups' })}</Typography>
  );

  if (data.hasNoGroups) {
    return (
      <SectionBlock title={title}>
        <SectionBlock withCard sx={{ mt: 2 }}>
          <EmptyState
            titleId="dashboard-teacher-EmptyGroups-title"
            subtitleId="dashboard-teacher-EmptyGroups-subtitle"
          />
        </SectionBlock>
      </SectionBlock>
    );
  }

  return (
    <ListAccordion
      header={<SectionAccordionHeader title={title} />}
      sx={{ border: 'none', borderRadius: 0 }}
    >
      <GroupsWidget
        data={data}
        canViewAttendance={canViewAttendance}
        canManageAttendance={canManageAttendance}
      />
    </ListAccordion>
  );
};

const SectionAccordionHeader: FC<{ title: ReactNode }> = ({ title }) => {
  const { expanded, toggle } = useContext(ListAccordionContext);

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      gap={1}
      onClick={toggle}
      sx={{ cursor: 'pointer' }}
    >
      {title}
      <IconButton inverse={!expanded} sx={{ transform: expanded ? 'rotate(180deg)' : undefined }}>
        <DropdownIcon />
      </IconButton>
    </Stack>
  );
};
